import React from 'react';
import { CheckCircle2, HardHat } from 'lucide-react';
export function ContractGlazing() {
  const exteriorPoints = ['Aluminum curtain walls', 'Exterior glass walls and lobbies', 'Slope glazing and specialty exterior glass', 'Total storefront systems', 'Ribbon windows and preglazed systems'];
  const contractPoints = ['Accurate commercial glass quotes and bid support', 'Fabrication and installation services', 'Custom hardware and glazing solutions', 'On-time project coordination for builders and owners', 'Service and maintenance for new and existing buildings'];
  return <section className="py-20 bg-navy-900 relative overflow-hidden border-t border-navy-800" data-id="element-671" data-mp="16ux3ycu2srk5">
      <div className="absolute inset-0 bg-glass-grid opacity-10 pointer-events-none" data-id="element-672" data-mp="1bn70ibpp4pve"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-673" data-mp="e5zxd6z88j78">
        <div className="max-w-3xl mb-14 anim-on-scroll" data-id="element-674" data-mp="j5ktzaqxcfgs">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary-500/15 text-primary-300 text-xs font-semibold uppercase tracking-normal mb-4" data-id="element-675" data-mp="j41evnh08agl">
            Contract Glazing
          </div>
          <h2 className="kosins-heading text-4xl md:text-5xl text-white mb-6" data-id="element-676" data-mp="1rj4fkhuxvdb9">
            Curtain Walls, Exterior Glazing & Contract Glazing
          </h2>
          <p className="text-lg text-slate-300 leading-relaxed" data-id="element-677" data-mp="1inoq0d17vkbh">
            Kosin’s Glass supports commercial construction and renovation with
            curtain wall systems, exterior glazing and full contract glazing
            services for builders, general contractors, architects and building
            owners across Michigan.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6" data-id="element-678" data-mp="zq3yey72i7n6">
          <div className="bg-navy-800/50 border border-navy-700 rounded-lg p-8 backdrop-blur-sm scroll-fade-up" style={{
          animationDelay: '0s'
        }} data-id="element-679" data-mp="zrf08sgyd5bn">
            <div className="flex items-center gap-3 mb-6" data-id="element-680" data-mp="2u1inrdw6252e">
              <div className="w-10 h-10 bg-primary-500/15 rounded-lg flex items-center justify-center" data-id="element-681" data-mp="rfwuyc6wyqch">
                <HardHat className="w-5 h-5 text-primary-300" data-id="element-682" data-mp="w8g9pchc7riv" />
              </div>
              <h3 className="kosins-heading text-2xl text-white" data-id="element-683" data-mp="ih2si56wj5r0">
                Exterior Glazing Systems
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-684" data-mp="mi4wezbrk5zb">
              {exteriorPoints.map((p, i) => <li key={i} className="flex items-start gap-3" data-id="element-685" data-mp="1a7z7pcgfpmhg" data-mpi={i}>
                  <CheckCircle2 className="w-5 h-5 text-primary-400 shrink-0 mt-0.5" data-id="element-686" data-mp="1f6sl74vq1dhm" />
                  <span className="text-slate-200" data-id="element-687" data-mp="117ap04g3ixy8">{p}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-navy-800/50 border border-navy-700 rounded-lg p-8 backdrop-blur-sm scroll-fade-up" style={{
          animationDelay: '0.1s'
        }} data-id="element-688" data-mp="164j94akt1c24">
            <div className="flex items-center gap-3 mb-6" data-id="element-689" data-mp="3qxo3frj3g8wr">
              <div className="w-10 h-10 bg-amber-500/15 rounded-lg flex items-center justify-center" data-id="element-690" data-mp="3ieje8besk8ce">
                <CheckCircle2 className="w-5 h-5 text-amber-400" data-id="element-691" data-mp="3ee0oqo0dfedd" />
              </div>
              <h3 className="kosins-heading text-2xl text-white" data-id="element-692" data-mp="3sd093jgup73q">
                Contract Glazing Capabilities
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-693" data-mp="3neoyv7mn8ukz">
              {contractPoints.map((p, i) => <li key={i} className="flex items-start gap-3" data-id="element-694" data-mp="2zpcv4na35eq2" data-mpi={i}>
                  <CheckCircle2 className="w-5 h-5 text-primary-400 shrink-0 mt-0.5" data-id="element-695" data-mp="2uq07w1fay5my" />
                  <span className="text-slate-200" data-id="element-696" data-mp="39eeb4dgmrw41">{p}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 text-center anim-on-scroll" data-id="element-697" data-mp="34mw69ebhlbds">
          <a href="#quote" className="inline-flex items-center justify-center bg-primary-600 hover:bg-primary-500 text-white font-semibold py-3.5 px-8 rounded-lg transition-colors" data-id="element-698" data-mp="2gxtqyd4brumg">
            Request a Contract Glazing Bid
          </a>
        </div>
      </div>
    </section>;
}